import React, { useState, useEffect } from 'react'
import { COOKIES } from 'utils/constants'
import CarDeliveryInfo from '@/modern/components/CarDeliveryInfo'
import { cookieCategoryIsActive, getEncryptedCookie } from '@/modern/utils/cookies'
import { useCookieNoticeState } from '@/store/context/cookie-notice-context'
import Icon from '@/modern/components/Icon'
import {
  Text,
  Form,
  LeftColumn,
  RightColumn,
  Input,
  CheckboxInput,
  CheckBox,
  ChangeInfo,
  InputContainer,
} from './style'
import { FormInfo } from '../style'

export default ({ register, triggerValidation, setContinueIsActive }) => {
  const { cookies } = useCookieNoticeState()
  const isActive = cookieCategoryIsActive(cookies, COOKIES.FORM_DATA)

  const [form, setForm] = useState({})
  const [hasCookies, setHasCookies] = useState(null)
  const [phoneMask, setPhoneMask] = useState('(99) 99999-9999')

  useEffect(() => {
    const formCookie =
      (isActive && getEncryptedCookie(COOKIES.FORM_DATA)) || null
    const fields = formCookie && formCookie.Principal

    if (!fields) return

    setForm(fields)
    setHasCookies(formCookie)
    setContinueIsActive(!!formCookie)
  }, [])

  const onBlur = () => {
    let errors = false
    triggerValidation('fullName').then(res => {
      errors = !res
      triggerValidation('email').then(res => {
        errors = !res
        triggerValidation('numberPhone').then(res => {
          errors = !res
          const isValid = !errors
          setContinueIsActive(isValid)
        })
      })
    })
  }
  const handlePhoneMask = e => {
    const isFixPhone = e.target.value.length === 14
    setPhoneMask(isFixPhone ? '(99) 9999-9999' : '(99) 99999-9999')
    onBlur()
  }

  const dataFormTest = 'form_videochamada'
  const dataInputNameTest = 'input_name'
  const dataInputEmailTest = 'input_email'
  const dataInputPhoneTest = 'input_phone'
  const dataCheckBoxCarDelivery = 'checkbox_cardelivery'
  const dataCheckBoxNewsLetter = 'checkbox_newsletter'

  return (
    <Form data-test-component={dataFormTest}>
      <LeftColumn>
        <FormInfo>
          Os itens do formulário e calendário são obrigatórios
        </FormInfo>
        <InputContainer data-test-component={dataInputNameTest} hasCookies={hasCookies}>
          {hasCookies && <Icon name="Person_1" fill="#5F5F6A" size="24" />}
          <Input
            data-qa="input_video_call_name"
            placeholder="Nome"
            name="fullName"
            inputRef={register}
            onBlur={onBlur}
            value={hasCookies && form.fullName}
            readOnly={!!hasCookies}
          />
        </InputContainer>

        <InputContainer data-test-component={dataInputEmailTest} hasCookies={hasCookies}>
          {hasCookies && <Icon name="Message_2" fill="#5F5F6A" size="24" />}
          <Input
            data-qa="input_video_call_email"
            placeholder="E-mail"
            name="email"
            inputRef={register}
            onBlur={onBlur}
            value={hasCookies && form.email}
            readOnly={!!hasCookies}
          />
        </InputContainer>

        <InputContainer data-test-component={dataInputPhoneTest} hasCookies={hasCookies}>
          {hasCookies && <Icon name="Phone" fill="#5F5F6A" size="24" />}
          <Input
            data-qa="input_video_call_phone"
            placeholder="Telefone"
            name="numberPhone"
            inputRef={register}
            onBlur={handlePhoneMask}
            mask={phoneMask}
            maskChar=""
            onFocus={() => setPhoneMask('(99) 99999-9999')}
            value={hasCookies && form.numberPhone}
            readOnly={!!hasCookies}
          />
        </InputContainer>

        <ChangeInfo
          hasCookies={hasCookies}
          type="button"
          onClick={() => setHasCookies(null)}
        >
          Editar informações
        </ChangeInfo>
      </LeftColumn>

      <RightColumn>
        <CarDeliveryInfo text="Conheça" isModal />
        <CheckboxInput data-test-component={dataCheckBoxCarDelivery}>
          <CheckBox type="checkbox" name="carDelivery" ref={register} />
          <Text>
            Tenho interesse em comprar este carro via CarDelivery e avisar o
            vendedor
          </Text>
        </CheckboxInput>
        <CheckboxInput data-test-component={dataCheckBoxNewsLetter}>
          <CheckBox type="checkbox" name="newsletter" ref={register} />
          <Text>
            Aceito o envio desta proposta para veículos similares, também aceito
            receber ofertas por canais de comunicação.
          </Text>
        </CheckboxInput>
      </RightColumn>
    </Form>
  )
}
